import React, { Component } from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import moment from 'moment-timezone';

import Table from '../components/table/table';
import TableRegisterButton from '../components/table/registerButton';
import ModalComponent from '../components/modal';

import NumbersHelper from '../helpers/numbers';

import RecommendedAction from '../app/store/actions/recommended';

import { history } from '../routers/AppRouter';
import ROUTES from '../data/routes';

class RecommendedPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: 20,
      page: 1,
      search: '',
      showModal: false,
      orderBy: 'DESC',
      field: 'id',
    };
  }

  componentDidMount() {
    this.searchRecommendeds();
  }

  updateValues = async (search = '', page = 1) => {
    await this.setState({ search, page });
    await this.searchRecommendeds();
  }

  searchRecommendeds = async () => {
    const {
      search, page, limit, orderBy = '', field = '',
    } = this.state;
    const skip = (page - 1) * limit;

    await this.props.searchItems(limit, skip, search, orderBy, field);
  }

  getValue = (item) => {
    if (item.type === 'percentage') {
      return NumbersHelper.toPercentage(item.value * 100);
    }

    const decimal = Number(item.value);
    return NumbersHelper.toCurrency(decimal);
  }

  deleteRecommendedModal = async (recommendedId) => {
    await this.setState({ selectItemToDelete: recommendedId, showModal: true });
  }

  deleteRecommended = async () => {
    const { selectItemToDelete } = this.state;

    if (selectItemToDelete) {
      await this.props.removeRecommended(selectItemToDelete);
      await this.setState({ selectItemToDelete: undefined, showModal: false });
      await this.searchRecommendeds();
    }
  }

  sortTable = async (field, orderBy) => {
    await this.setState({ orderBy, field });
    await this.searchRecommendeds();
  }

  render() {
    const {
      limit, page, showModal,
    } = this.state;
    const { recommendeds = {} } = this.props;

    const tableHeader = [
      { key: 'id', value: 'ID' },
      { key: 'code', value: I18n.t('code') },
      { key: 'description', value: I18n.t('description') },
      { key: 'categoryName', value: I18n.t('categoryName2') },
      { key: 'action', value: I18n.t('action') },
    ];

    const tableData = (recommendeds.recommended || []).map((row, index) => ({
      key: index,
      id: row.id,
      code: row.product.code,
      description: row.product.description,
      categoryName: row.category && (row.category.name || ''),     
      action: (
        <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
          <div className="btn-group" role="group">
            <button
              id="btnGroupDrop1"
              type="button"
              className="btn btn-secondary dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <Translate value="action" />
            </button>
            <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
              <button
                type="button"
                onClick={() => history.push({
                  pathname: ROUTES.FORM,
                  screenComming: 'recommended',
                  item: row,
                })}
                className="dropdown-item dropdown-table"
              >
                <Translate value="edit" />
              </button>

              <button
                type="button"
                className="dropdown-item dropdown-table"
                onClick={() => this.deleteRecommendedModal(row.id)}
              >
                <Translate value="delete" />
              </button>
            </div>
          </div>
        </div>
      ),
    }));

    const tableButtons = (
      <React.Fragment>
        <TableRegisterButton route={{ pathname: ROUTES.FORM, screenComming: 'recommended' }} />
        <button
          onClick={() => history.push(ROUTES.UPLOAD_RECOMMENDEDS)}
          type="button"
          className="btn btn-secondary margin-left-10"
        >
          <Translate value="import" />
        </button>

        <button
          onClick={() => this.props.getCsvRecommendedsReport()}
          type="button"
          className="btn btn-secondary margin-left-10"
        >
          <Translate value="export" />
        </button>
      </React.Fragment>
    );

    return (
      <div className="main-div-tables">
        <ModalComponent
          title={I18n.t('delete')}
          body={I18n.t('deleteRecommendedModal')}
          visible={showModal}
          closeModal={() => this.setState({ showModal: false })}
          titleOkButtoon={I18n.t('confirm')}
          size={{ width: '300px', height: '170px' }}
          showButtons
          showCancel
          confirmModal={this.deleteRecommended}
        />

        <Table
          title={I18n.t('recommendeds')}
          buttons={tableButtons}
          header={tableHeader}
          lines={tableData}
          page={page}
          perPage={limit}
          count={recommendeds.recommended ? recommendeds.recommended.length : 0}
          searchItems={this.updateValues}
          showItemsCount
          sortTable={this.sortTable}
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  removeRecommended: id => dispatch(RecommendedAction.removeRecommended(id)),
  searchItems: (limit, skip, search, order, field) => dispatch(
    RecommendedAction.getRecommendeds(limit, skip, search, order, field),
  ),
  getCsvRecommendedsReport: () => dispatch(RecommendedAction.getCsvRecommendedsReport()),
});

const mapStateToProps = state => ({
  recommendeds: state.recommendeds.recommendeds,
});

export default connect(mapStateToProps, mapDispatchToProps)(RecommendedPage);
